import React, { Component } from "react";
import PeerTabs from './PeerTabs/PeerTabs.js';
import Layout from "antd/lib/layout";
// import settings from "./particles.js";
// import Particles from "react-particles-js";
import Tour from "./Tour.js";
import Button from "antd/lib/button";
import Affix from "antd/lib/affix";
import logo from "./logo.png";
import Social from "./Social.js";
const { Content } = Layout;

class App extends Component {
  state = {
    scrollToSteps: true,
    showTour: true,
    inProgress: false,
  }

  startProgress = () => {
    this.setState({
      inProgress: true
    })
  }

  stopProgress = () => {
    this.setState({
      inProgress: false
    })
  }

  tourVisibility = (index) => {
    if (index === "0") {
      this.setState({
        scrollToSteps: true
      })
    } else {
      this.setState({
        scrollToSteps: false
      })
    }
  }

  showTour = () => {
    this.setState({
      showTour: true
    })
  }

  closeTour = () => {
    this.setState({
      showTour: false
    })
  }

  render() {
    return (
      <div>
        <Tour 
          scrollToSteps={this.state.scrollToSteps}
          shouldShowTour={this.state.showTour}
          showTour={this.showTour}
          closeTour={this.closeTour}
          startProgress={this.startProgress}
          stopProgress={this.stopProgress}
        />
        <Content 
          style={{ paddingLeft: "5vw", paddingRight: "5vw", paddingTop: "3.5vw", paddingBottom: "3.5vw" }}
        >
          {/* <Particles
            params={settings}
            style={{
              display: "block",
              paddingTop: "7vw",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "inherit"
            }} 
          /> */}
          <Affix style={{right: "5vw", position: "absolute"}}>
            <Button 
              type="primary"
              className="tour-button"
              icon="rocket"
              onClick={this.showTour}
            >
              <span style={{fontWeight: "500"}}>{this.state.inProgress ? "CONTINUE DEMO" : "START DEMO"}</span>
            </Button>
          </Affix>
          <img
            className="welcome whats-new final"
            src={logo}
            alt="logo.png"
            style={{ width: "60px", marginRight: "auto", marginLeft: "auto", display: "block" }}
          />
          
          <h1
            className="p2p"
            style={{
              fontSize: "24pt",
              fontWeight: "700",
              marginLeft: "10px",
              marginBottom: "15px",
              letterSpacing: "1px",
              position: "relative",
              zIndex: "999",
            }}
          >
            PEERS
          </h1>
          <PeerTabs 
            tourVisibility={this.tourVisibility}  
          />
          <Social />
        </Content>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js